import { render, staticRenderFns } from "./ApplicantDetails.vue?vue&type=template&id=703f4a44"
import script from "./ApplicantDetails.vue?vue&type=script&lang=ts"
export * from "./ApplicantDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports